<!-- START CONTENT -->
<section id="main-content" class="sidebar_shift">
  <section class="wrapper main-wrapper row" [ngClass]="{'minimised' : selectedTestAccession != undefined}">

    <div class="row">
      <div class="col-sm-4">
        <result-list-filter (onFilter)="onFilter($event)"></result-list-filter>
      </div>
      <div class="col-sm-8">
        <!-- START SEARCH RESULTS -->
        <div>
          <div class="content-body">
            <div class="row overflow-scroll">
              <div class="col-xs-12">
                <table class="table">
                  <thead>
                    <tr>
                      @if(UserSource.Site !== 'TRIALS') {
                      <th [class.uparrow]="chevronUp('Surname')" [class.downarrow]="chevronDown('Surname')" (click)="flipSort('Surname')">Name</th>
                      }
                      @if(UserSource.Site  == 'TRIALS') {
                      <th [class.uparrow]="chevronUp('Surname')" [class.downarrow]="chevronDown('Surname')" (click)="flipSort('Surname')">Subject</th>
                      }
                      @if(!SourceFilterEnabled) {
                      <th (click)="enableSourceFilter()" [class.uparrow]="chevronUp('SourceCode')" [class.downarrow]="chevronDown('SourceCode')">Source</th>
                      }
                      @if(SourceFilterEnabled) {
                      <th>
                        <select class="form-control input-md m-bot15" (change)="onFilterSourceChange($event)">
                          @for(source of FilterSources; track source) {
                          <option [value]="source">
                            {{source}}
                          </option>
                          }
                        </select>
                      </th>
                      }
                      <th (click)="flipSort('Reference')" [class.uparrow]="chevronUp('Reference')" [class.downarrow]="chevronDown('Reference')">Reference</th>
                      <th (click)="flipSort('RequestDate')" [class.uparrow]="chevronUp('RequestDate')" [class.downarrow]="chevronDown('RequestDate')">Date</th>
                      <th>Test Groups</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for(testAccession of TestAccessions; track testAccession.LabNumber) {
                    <tr>
                      <td class="col-lg-3">
                        {{testAccession.ForeName}} {{testAccession.Surname}}
                      </td>
                      <td class="col-lg-1">
                        {{testAccession.SourceCode}}
                      </td>
                      <td class="col-lg-1">
                        {{testAccession.Reference}}
                      </td>
                      <td class="col-lg-2">
                        {{testAccession.RequestDate|date:'dd/MM/yyyy HH:mm'}}
                      </td>
                      <td class="col-lg-3">
                        @for(testgroup of testAccession.Tests; track testgroup.TestCode; let i = $index) {
                        <span><label [class.highlight]="highLighted(testgroup)">{{testgroup.TestCode}}</label>@if(i < testAccession.Tests.length - 1){<span> | </span>}</span>
                        }
                      </td>
                      <td class="col-lg-1">
                        <input type="button" value="Details" (click)="viewDetails(testAccession)" class="btn btn-success" />
                      </td>
                    </tr>
                    }
                    <tr>
                      <td></td>
                      <td (click)="decrementPage()">
                        @if(currentPage > 1) {
                        <h1 matTooltip="Previous Page"
                            matTooltipPosition="above"
                            matTooltipHideDelay="1000">
                          <
                        </h1>
                        }
                      </td>
                      <td></td>
                      <td></td>
                      <td (click)="incrementPage()">
                        @if(TestAccessions.length >= 100) {
                        <h1 matTooltip="Next Page"
                            matTooltipPosition="above"
                            matTooltipHideDelay="1000">
                          >
                        </h1>
                        }
                      </td>
                      @if(TestAccessions.length >= 100) {
                      <td>Page : {{currentPage}}</td>
                      }
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!--</section>-->

        </div>
        <!-- END SEARCH RESULTS -->
      </div>
    </div>
  </section>
  <section class="resultdetails">
    <div class="row">
      <div class="col-sm-12">
        <result-details (onHide)="hideDetails()" [_testAccession]="selectedTestAccession"></result-details>
      </div>
    </div>
  </section>
</section>
